$(document).ready(function(){




    $('body').addClass('page-ready');



$('.js-open-mobile-nav').click(function(){
    if ($('body').hasClass('mobile-nav-is-open')){
    closeMobileNav();
    } else {
    openMobileNav();
    }
});


    function openMobileNav(){
        $('body').addClass('mobile-nav-is-open');
    }

    function closeMobileNav(){
        $('body').removeClass('mobile-nav-is-open');
    }


    const animateRows = document.querySelectorAll('.js-view-check');




     var scrollThrottleTimeout;
            $(window).bind(
                'scroll',
                function()
                {
                    if (!scrollThrottleTimeout) {
                        scrollThrottleTimeout = setTimeout(
                            function()
                            {
                                //  console.log('test');
                                onPageScroll();
                                scrollThrottleTimeout = null;
                            },
                            100
                        );
                    }
                }
            );


            function onPageScroll(){
                // console.log("Scrolled");
                if ($(window).scrollTop() >= 30) {
                    $('.header').addClass('fixed');
                    $('.body').addClass('header-is-fixed');
                } else {
                    $('.header').removeClass('fixed');
                }
            }

onPageScroll();


                $('.faq-post-block__question[aria-controls]').click(function(){
                    // $(this).toggleClass('open-accordion');

                    var ariaControlsId = $(this).attr('aria-controls');
                    // $('.accordion-block__main-content[id="' + ariaControlsId + '"]').slideToggle();

                    var ariaExpanded = $(this).attr('aria-expanded');

                    if (ariaExpanded == 'false'){
                        $(this).attr("aria-expanded","true");
                    } else {
                        $(this).attr("aria-expanded","false");
                    }

                });



    $(".js-scroll-to").click(function (){
    	var scrollTarget = $(this).attr('scroll-to');
        $('html, body').animate({
            scrollTop: $('.'+scrollTarget).offset().top - 100
        }, 800);
    });

    $(".js-scroll-to-element").click(function (){
        var scrollTarget = $(this).attr('scroll-to');
        $('html, body').animate({
            scrollTop: $(scrollTarget).offset().top - 100
        }, 800);
    });


    // $('.js-replay-video').click(function(){
    //     $(this).parents('.inline-video__embed').removeClass('is-completed-video');
    // });

    //Checks on click targets. Closes certain menus dependant on target
    $(document).click(function(e) {
        e.stopPropagation();
        var target = e.target;
        // console.log(target);

        if (!$(target).is('.js-open-search') && !$(target).parents().is('.js-open-search') && !$(target).is('.header__search-field') && !$(target).parents().is('.banderole-open-search-btn')  && !$(target).is('.ps__thumb-y') && !$(target).parents().is('.ps__rail-y')) {
            closeSearch();
        }

    });




    // **************************************
    // Search Start

    $('.js-open-search').click(function(e){
        e.preventDefault();
        openSearch();
    });

    $('.js-close-search').click(function(e){
        e.preventDefault();
        closeSearch();
    });



    function openSearch(){
        $('body').addClass('is-searching');
        $( "#search" ).focus();
    }

    function closeSearch(){
        $('body').removeClass('is-searching');
    }



    $(document).ajaxStart(function(){
        $('.ajax-loader').fadeIn();
    });
    $(document).ajaxComplete(function(){
        $('.ajax-loader').fadeOut();
    });
    $("#search").keyup(function(event) {
        if (event.keyCode === 13) {
            $("#submit-filters").click();
        }
    });

    $('#search').keyup(_.debounce(doSearch , 500));
    var historySupport = !!(window.history && history.pushState);
    var dataLayer = window.dataLayer = window.dataLayer || [];

    function doSearch(){
        var search = $('#search').val();
        // console.log(search.length);
        if (search.length == 0){
            $('#query-container').fadeOut();
        } else {
            if($('#search')[0].checkValidity()){
                ajaxCall(search);
                // e.stopPropagation();
                // Data layer Functionality
                dataLayer.push({
                    'event': 'searchQuery',
                    'searchTerm': search,
                }); 
            }
            else{
                $.fancybox.open($("#search-error"));
            }
        }

    }


    function ajaxCall(search){
        $('.search-panel__loading').fadeIn();
        $('#query-container').fadeOut();
        $.ajax('/hidden/search-ajax-request?&q='+search, {
            dataType : 'html',
            success : function (response) {
                $('.search-panel__loading').fadeOut();
                // console.log(response);
                refreshResults(response);
                $('#query-container').fadeIn();
                if (historySupport) {
                    // Update the browser's address bar
                    //   history.pushState(null, null, '/search/results?&q='+search);
                }
                $('.search-result__link').each(function(){
                    $(this).on('click', function(e){
                        e.preventDefault();
                        //dataLayer
                        dataLayer.push({  
                            'event': 'searchResultClick',  
                            'searchTerm': search, 
                            'searchResultLinkTitle': $(this).children('.search-result__title').text(),
                            'searchResultLink': $(this).attr('href')
                        });
                        // console.log(dataLayer);
                        window.location.href = $(this).attr('href');

                    })
                });
            }
        });
    }
    function refreshResults (html)
    {
        var $html = $('<div />').append(html);
        // $.when($('#query-container').fadeOut(),$('#query-header').fadeOut(),$('#query-title').fadeOut()).then(function(){
        // $('#query-breadcrumbs').html($html.find('#query-breadcrumbs').html()).fadeIn();
        $('#query-container').html($html.find('.search-results-wrapper').html()).fadeIn();
        // $('#query-header').html($html.find('#query-header').html()).fadeIn();
        // $('#query-title').html($html.find('#query-title').html()).fadeIn();
        // })

        const searchResultsScroller = document.querySelector('#search-results-scroller');
        const ps = new PerfectScrollbar(searchResultsScroller);


    }


    // Search End
    // **************************************

    // Handel close on escape
    $(document).on('keydown', function(e) {
        if ($('body').hasClass('is-searching')) {
            if (e.key === 'Escape' || e.keyCode === 27) {
                console.log('closed');
                $('body').removeClass('is-searching');
            }
        }
    });

    // Handle Tab key on the close button
    $('.header-close-search-btn.js-close-search').on('keydown', function(e) {
        if (e.key === 'Tab' || e.keyCode === 9) {
            e.preventDefault();
            // Check if there are search results
            if ($('.search-results').length && $('.search-results li').length > 0) {
                // Focus on the first search result link
                $('.search-results li:first-child a').focus();
            }
        }
    });

    // Handle Shift+Tab key on the first search result link
    $(document).on('keydown', '.search-results li:first-child a', function(e) {
        if (e.shiftKey && (e.key === 'Tab' || e.keyCode === 9)) {
            e.preventDefault();
            // Focus back on the close button
            $('.header-close-search-btn.js-close-search').focus();
        }
    });

    // Handle Shift+Tab on other search result links to navigate up
    $(document).on('keydown', '.search-results li:not(:first-child) a', function(e) {
        if (e.shiftKey && (e.key === 'Tab' || e.keyCode === 9)) {
            e.preventDefault();
            // Move focus to the previous search result link
            $(this).closest('li').prev().find('a').focus();
        }
    });

    // Handle Shift+Tab on the close button to move focus back to the search input field
    $('.header-close-search-btn.js-close-search').on('keydown', function(e) {
        if (e.shiftKey && (e.key === 'Tab' || e.keyCode === 9)) {
            e.preventDefault();
            // Focus back on the search input field
            $('#search').focus();
        }
    });

});


